import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotSection from "./components/HotSection";
import CategorySection from "./components/CategorySection";
import FollowSection from "./components/FollowSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <HotSection />
        <CategorySection />
        <FollowSection />
        <AboutSection />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}